__turbopack_context__.v({
  "profile-form": "mSKvIq_profile-form",
  "profile-form__content": "mSKvIq_profile-form__content",
  "profile-form__content--reduce-spacing": "mSKvIq_profile-form__content--reduce-spacing",
  "profile-form__fieldset": "mSKvIq_profile-form__fieldset",
  "profile-form__footer": "mSKvIq_profile-form__footer",
  "profile-form__heading": "mSKvIq_profile-form__heading",
  "profile-form__legend": "mSKvIq_profile-form__legend",
  "profile-form__separator": "mSKvIq_profile-form__separator",
  "profile-form__social-links-fields": "mSKvIq_profile-form__social-links-fields",
  "profile-form__sub-heading": "mSKvIq_profile-form__sub-heading",
});
